import { ChangeEvent, memo } from 'react';

interface Props {
  anotaciones: any[];
  handleAnotacionesDropsetChange: (event: ChangeEvent<any>, index: number) => void;
}

const AnotacionesDropset = ({ anotaciones, handleAnotacionesDropsetChange } : Props ) => (
  <div className="ser-dropset-list">
    {[...Array(3)].map((_, index) => (
      <div className="ser-dropset-item" key={index}>
        <span className="ser-dropset-label">Dropset {index + 1}</span>
        <textarea
          className="ser-textarea ser-textarea--sm"
          placeholder="Anotación..."
          value={anotaciones[index]}
          onChange={(ev) => handleAnotacionesDropsetChange(ev, index)}
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          spellCheck={false}
          rows={1}
        />
      </div>
    ))}
  </div>
);

export default memo(AnotacionesDropset);